import React from 'react'
import ArrowLeftSvg from 'images/modules/Manage/i-arrow-left.svg?raw'

export { default as ArrowLeftUrl } from 'images/modules/Manage/i-arrow-left.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ArrowLeftSvg}} />
)
